<span>
  <ucs-icon [class]="'grey'" [shape]="'calculator_'+ type"
            [size]="18"></ucs-icon>
  <span class="text-type ms-1">
      <strong>{{ text | translate }}</strong>
  </span>
</span>
